'use strict';

const tslib_es6 = require('../../../tslib.es6-CZ43up4V.js');
const react = require('@emotion/react');
const React = require('react');
const theme_Colors = require('../../../theme/Colors.cjs.js');
require('../../../theme/Shadows.cjs.js');
require('../../../theme/Typography.cjs.js');
const components_navigation_Link_Link = require('../Link/Link.cjs.js');
const components_navigation_PageNavigation_PageNavigationContext = require('./PageNavigationContext.cjs.js');

const Styles = {
  link: react.css`
    display: block !important;
    text-decoration: none !important;

    & {
      &:focus {
        border-radius: 3px !important;
        color: ${theme_Colors.Colors.UiPrimaryStrongest} !important;
        outline: 2px solid ${theme_Colors.Colors.UiPrimaryStrongest} !important;
        outline-offset: -1px !important;
      }
    }
  `,
  row: react.css`
    width: 100%;

    & {
      &:focus {
        border-radius: 3px !important;
        color: ${theme_Colors.Colors.UiPrimaryStrongest} !important;
        outline: 2px solid ${theme_Colors.Colors.UiPrimaryStrongest} !important;
        outline-offset: -1px !important;
      }
    }
  `
};
function PageNavigationRow({ content: Content, isSelectable = true, item, nestedList: Children, onSelect }) {
  const [hover, setHover] = React.useState(false);
  const context = React.useContext(components_navigation_PageNavigation_PageNavigationContext);
  const { id, setId } = context;
  const selected = item.id === id;
  const handleOnSelect = React.useCallback((event) => {
    if (onSelect) {
      const itemWithNoChildren = tslib_es6.__rest(item, ["children"]);
      onSelect(itemWithNoChildren, event);
    }
    if (isSelectable) {
      setId(item.id);
    }
  }, [isSelectable, item, onSelect, setId]);
  const linkContent = React.useMemo(() => item.href ? react.jsx(
    components_navigation_Link_Link.Link,
    { css: Styles.link, href: item.href, onBlur: () => setHover(false), onClick: (e) => {
      handleOnSelect(e);
      e.stopPropagation();
    }, onKeyDown: (e) => {
      if (e.key === "Enter") {
        handleOnSelect(e);
        e.stopPropagation();
      } else if (e.key === " ") {
        e.preventDefault();
      }
    }, onFocus: () => setHover(true), onMouseEnter: () => setHover(true), onMouseLeave: () => setHover(false) },
    react.jsx(Content, { hover, selected })
  ) : react.jsx(
    "div",
    { "aria-label": item.title, css: Styles.row, "data-zds": true, onBlur: () => setHover(false), onClick: (e) => handleOnSelect(e), onFocus: () => setHover(true), onKeyDown: (e) => {
      if (e.key === "Enter" || e.key === " ") {
        e.preventDefault();
        handleOnSelect(e);
      }
    }, onMouseEnter: () => setHover(true), onMouseLeave: () => setHover(false), role: "button", tabIndex: 0 },
    react.jsx(Content, { hover, selected })
  ), [handleOnSelect, hover, item.href, item.title, selected]);
  return react.jsx(
    "li",
    { "data-zds": true },
    linkContent,
    Children && react.jsx(Children, null)
  );
}

module.exports = PageNavigationRow;
//# sourceMappingURL=PageNavigationRow.cjs.js.map
